// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from '../Messaging.scss';
import classNames from 'classnames/bind';
import moment from 'moment/moment';
import sanitizeHtml from 'sanitize-html';
import update from 'immutability-helper';

import avatarStyle from '../../../../../assets/styles/avatar.scss';
import defaultPic from '../../../../../assets/img/profileplaceholder.jpg';

import type { OrderMessage, UserMini, User } from '../../../../../entities';

type Props = {
  +userId: string;
  +user: User;
  +messages: OrderMessage[];
  +color: 'blue' | 'orange';
  +traveler: UserMini;
  +purchaser: UserMini;
  +handleOpenPhoto: (image: string) => void;
};

export default class Messages extends Component<Props> {
  divRef: HTMLDivElement;

  componentDidMount() {
    this.divRef.scrollTop = this.divRef.scrollHeight;
  }

  componentDidUpdate(prevProps: Props) {
    const { messages } = this.props;
    if (messages.length !== prevProps.messages.length) {
      this.divRef.scrollTop = this.divRef.scrollHeight;
    }
  }

  render() {
    const { userId, messages, color, purchaser, traveler, handleOpenPhoto, user } = this.props;
    // NOTE: we will always receive the one we need, not both of them
    const userMini: UserMini = traveler || purchaser;

    const messagesContent = userMini && messages && messages.map((message: OrderMessage, n: number) =>
      !!message && !!(message.message || message.image) && (message.image ? message : update(message, {
        message: {
          $set: sanitizeHtml(message.message, {
            allowedTags: ['p', 'a', 'br'],
            allowedAttributes: {
              a: ['href', 'target'],
            },
          }),
        },
      }))
    ).filter((message: OrderMessage) => !!(message.message || message.image))
      .map((message: OrderMessage, n: number) => {
          const isOwner = message.transmitterId === user.id;
          const fullName = isOwner ? `${user.firstName}` : `${userMini.firstName}`;
          const userImage = isOwner ? user.image : userMini.image;
          return (
            <label key={n}
                   className={classNames(style.message,
                     { [style.loading]: !!message.loading })}>
              <section className={style.left}>
                <img className={classNames(avatarStyle.avatar, style.avatar)}
                     src={userImage || defaultPic}/>
                <section className={style.user}>
                  <p className={classNames(style.title, {
                    [style.orange]: isOwner && !traveler,
                    [style.lightBlue]: isOwner && !purchaser,
                  })}>
                    {fullName}</p>
                  {!!message.message &&
                  <div className={style.textWrap}
                       dangerouslySetInnerHTML={{ __html: message.message }}/>}
                  {!!message.image &&
                  <img className={style.image}
                       src={message.image}
                       alt="image"
                       onClick={() => handleOpenPhoto(message.image)}/>}
                </section>
              </section>
              <p className={style.timestamp}>
                {moment(message.createdAt).format('DD/MM, HH:mm')}
              </p>
            </label>)
        }
      );
    return (
      <div ref={(ref: any) => this.divRef = ref} className={style.messages}>
        {messagesContent}
      </div>
    );
  }
}

Messages.propTypes = {
  userId: PropTypes.string.isRequired,
  messages: PropTypes.array.isRequired,
  color: PropTypes.string.isRequired,
  traveler: PropTypes.object,
  purchaser: PropTypes.object,
  handleOpenPhoto: PropTypes.func.isRequired,
  user: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/order/components/Messaging/Messages/Messages.jsx